/**
 * Asserts that a required environment variable is defined, throwing a clear
 * error at module-load time otherwise. Shared helper for the `*.env.ts`
 * credential modules so the guard is defined once rather than copy-pasted.
 */
export function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage);
  }

  return v;
}
